import { render, staticRenderFns } from "./IconPaperplane.vue?vue&type=template&id=fb77578a&scoped=true"
import script from "./IconPaperplane.vue?vue&type=script&lang=js"
export * from "./IconPaperplane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77578a",
  null
  
)

export default component.exports